import { useCallback } from 'react';
import webApp from '@happylife-a/web-app';
import webCore from '@happylife-a/web-core';
import appBranding from '@happylife-a/branding';

function useShowProduct({ productSlug, productId, productDetailId }) {
  const navigate = webApp.router.useNavigate();
  const { locale } = webCore.contexts.useTranslation();
  const appBrandOpenProductFromNewTab = appBranding.configs.environments.getField(
    appBranding.fields.brand.UI.Settings.Webapp.Product.OpenInNewTab
  );
  const { dispatch } = webApp.contexts.useModal();

  const openQuickViewModal = useCallback(() => {
    if (!productId || !productDetailId) {
      return;
    }

    dispatch({
      type: 'open',
      modal: webApp.constants.ENUM_MODAL_QUICK_VIEW,
      props: {
        productSlug: productSlug,
        productId: productId,
        activeDetailId: productDetailId,
      },
    });
  }, [productId, productDetailId]);

  const navigateToProductPage = useCallback(() => {
    if (!productSlug || !productDetailId) {
      return;
    }

    if (appBrandOpenProductFromNewTab) {
      window.open(
        `${window.location.origin}/${locale}/products/${productSlug}?detailId=${productDetailId}`,
        '_blank'
      );
    } else {
      navigate(`/products/${productSlug}?detailId=${productDetailId}`);
    }
  }, [productSlug, productDetailId]);

  const displayProductInfo = useCallback(() => {
    navigateToProductPage();
  }, []);

  return {
    openQuickViewModal: openQuickViewModal,
    navigateToProductPage: navigateToProductPage,
    displayProductInfo: displayProductInfo,
  };
}

export default useShowProduct;
